// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1C9Qb","icon":"SortAdornment_icon__D7cAa","up":"SortAdornment_up__XEVsa","down":"SortAdornment_down__2qcBV","active":"SortAdornment_active__184e1"};